import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import ne from "./locales/ne.json";

const localStorageDetector = {
  type: "languageDetector" as const,
  async: false,
  detect: (): string => {
    return localStorage.getItem("user_language") || "en";
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  cacheUserLanguage: () => {},
};

i18n
  .use(localStorageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      fr: { translation: fr },
      de: { translation: de },
      ne: { translation: ne },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

window.addEventListener("storage", (event) => {
  if (event.key === "user_language" && event.newValue) {
    i18n.changeLanguage(event.newValue);
  }
});

window.addEventListener("languageChange", ((event: CustomEvent) => {
  if (event.detail?.language) {
    i18n.changeLanguage(event.detail.language);
  }
}) as EventListener);

export default i18n;
